import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getGlobalImeiCode,
  getGlobalImeiCodeById,
  updateGlobalImei,
  updateGlobalImeiStatus,
} from "../../store/actions/GlobalImei.js";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Spinner,
  Modal,
  Badge,
} from "reactstrap";
import { EyeOutlined, UserOutlined, LoadingOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import CustomToggleSwitch from "../../components/CustomToggleSwitch.js";

const GlobalImei = () => {
  document.title = "Global IMEI";
  const [isLoading, setIsLoading] = useState(true);
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [currentStatus, setCurrentStatus] = useState("Pending");
  const [userModalVisible, setUserModalVisible] = useState(false);
  const [loadingUserDetails, setLoadingUserDetails] = useState(false);
  const [filterStatus, setFilterStatus] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();
  const globalImeiCode = useSelector((state) => state.GlobalImei.list || []);
  useEffect(() => {
    const fetchImeiCodes = async () => {
      try {
        await dispatch(getGlobalImeiCode());
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching IMEI codes:", error);
        setIsLoading(false);
      }
    };

    fetchImeiCodes();
  }, [dispatch]);

  const handleViewImages = (record) => {
    if (record.imagesLive && record.imagesLive.length) {
      setCurrentImages(record.imagesLive);
      setSelectedRecord(record);
      setCurrentStatus(
        record.globalImeiStatus === 0
          ? "Pending"
          : record.globalImeiStatus === 1
          ? "Approved"
          : "Rejected"
      );
      setImageModalVisible(true);
    } else {
      console.log("No images available for this record");
    }
  };

  const selectedImeiDetails = useSelector((state) => state.GlobalImei.single);
  console.log(selectedImeiDetails, "selectedImeiDetails");
  const handleViewUserDetails = async (record) => {
    setSelectedRecord(record);
    setUserModalVisible(true);
    setLoadingUserDetails(true);

    try {
      // Call the API with the record ID as parameter
      await dispatch(getGlobalImeiCodeById({ id: record.id }));
      console.log("Fetched user details for ID:", record.id);
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoadingUserDetails(false);
    }
  };

  const statusMap = {
    Pending: 0,
    Approved: 1,
    Rejected: 2,
  };
  console.log(selectedRecord, "selected Record");
  const handleUpdate = async (statusLabel) => {
    setCurrentStatus(statusLabel); // Update UI selection

    const parsedStatus = statusMap[statusLabel]; // Convert label to number

    const updatedData = {
      userId: selectedRecord.userId,
      customerId: selectedRecord.customerId || "",
      databaseName: selectedRecord.databaseName || "",
      id: selectedRecord.id || "",
      imeiNo: selectedRecord.imeiNo || "",
      globalImeiStatus: parsedStatus || "",
      createdBy: selectedRecord.createdBy || "",
      reason: selectedRecord.reason || "",
      status: selectedRecord.status || "",
      color: selectedRecord.color || "",
      brand: selectedRecord.brand || "",
      model: selectedRecord.model || "",
      ram: selectedRecord.ram || "",
      rom: selectedRecord.rom || "",
    };
    await dispatch(updateGlobalImeiStatus(updatedData));
    await dispatch(getGlobalImeiCode());
  };

  const handleUpdateFromTable = async (record, statusLabel) => {
    const parsedStatus = statusMap[statusLabel]; // Converts to 0,1,2

    // Validate required fields before sending
    if (!record.imeiNo) {
      console.error("IMEI number is required");
      return;
    }
    if (!record.createdBy) {
      console.error("CreatedBy is required");
      return;
    }

    const updatedData = {
      id: record.id, // Make sure this is a number
      databaseName: record.databaseName || "",
      imeiNo: record.imeiNo, // Required field - no fallback
      globalImeiStatus: parsedStatus,
      createdBy: record.createdBy, // Required field - no fallback
      reason: record.reason || "",
      status: record.status !== undefined ? record.status : true,
      color: record.color || "",
      brand: record.brand || "",
      model: record.model || "",
      ram: record.ram || "",
      rom: record.rom || "",
    };
    // Conditionally add userId and customerId only if truthy (not null/undefined/false/0)
    if (record.userId != null) updatedData.userId = record.userId;
    if (record.customerId != null) updatedData.customerId = record.customerId;

    try {
      await dispatch(updateGlobalImeiStatus(updatedData));
      await dispatch(getGlobalImeiCode());
    } catch (error) {
      console.error("Error updating IMEI status from table:", error);
    }
  };

  const getStatusBadgeColor = (status) => {
    if (status === 0 || status === false) return "warning";
    if (status === 1) return "success";
    if (status === 2) return "danger";
    return "secondary";
  };

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Global IMEI</Breadcrumb.Item>
      </Breadcrumb>

      <Container fluid>
        <Card className="p-4">
          <Row className="mb-3 d-flex align-items-center justify-content-between">
            <Col md="8">
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <Button
                  onClick={() => setFilterStatus("All")}
                  style={{
                    backgroundColor:
                      filterStatus == "All" ? "#AFDDFF" : "#4E71FF",
                    boxShadow:
                      filterStatus == "All" ? "2px 2px 2px 2px black" : "",
                  }}
                >
                  All
                </Button>
                <Button
                  onClick={() => setFilterStatus("Approved")}
                  style={{
                    backgroundColor:
                      filterStatus == "Approved" ? "#67AE6E" : "#4E71FF",
                    boxShadow:
                      filterStatus == "Approved" ? "2px 2px 2px 2px black" : "",
                  }}
                >
                  Approved
                </Button>
                <Button
                  onClick={() => setFilterStatus("Pending")}
                  style={{
                    backgroundColor:
                      filterStatus == "Pending" ? "#FEBA17" : "#4E71FF",
                    boxShadow:
                      filterStatus == "Pending" ? "2px 2px 2px 2px black" : "",
                  }}
                >
                  Pending
                </Button>
                <Button
                  onClick={() => setFilterStatus("Rejected")}
                  style={{
                    backgroundColor:
                      filterStatus == "Rejected" ? "#BE3D2A" : "#4E71FF",
                    boxShadow:
                      filterStatus == "Rejected" ? "2px 2px 2px 2px black" : "",
                  }}
                >
                  Rejected
                </Button>
                <Button
                  onClick={() => setFilterStatus("MissingUserInfo")}
                  style={{
                    backgroundColor:
                      filterStatus === "MissingUserInfo"
                        ? "#123458"
                        : "#4E71FF",
                    boxShadow:
                      filterStatus === "MissingUserInfo"
                        ? "2px 2px 2px 2px black"
                        : "",
                  }}
                >
                  Other Users
                </Button>
                <Button
                  onClick={() => setFilterStatus("FoundUserInfo")}
                  style={{
                    backgroundColor:
                      filterStatus === "FoundUserInfo" ? "#C599B6" : "#4E71FF",
                    boxShadow:
                      filterStatus === "FoundUserInfo"
                        ? "2px 2px 2px 2px black"
                        : "",
                  }}
                >
                  Portal User
                </Button>
              </div>
            </Col>
            <Col md="4">
              <input
                type="text"
                placeholder="Search IMEI..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  fontSize: "0.95rem",
                }}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <h2>Global IMEI Records</h2>
            </Col>
          </Row>

          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <Table
              responsive
              striped
              bordered
              hover
              style={{ border: "1px solid #90C67C", fontFamily: "math" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "8%" }}>IMEI Number</th>
                  <th style={{ width: "8%" }}>Reason</th>
                  <th style={{ width: "8%" }}>Action</th>
                  <th style={{ width: "8%" }}>Status</th>
                  <th style={{ width: "8%" }}>Name</th>
                  <th style={{ width: "8%" }}>Mobile No</th>
                  <th style={{ width: "8%" }}>Images</th>
                  <th style={{ width: "8%" }}>Brand</th>
                  <th style={{ width: "8%" }}>Model</th>
                  <th style={{ width: "8%" }}>Color</th>
                  <th style={{ width: "8%" }}>Storage</th>
                  <th style={{ width: "8%" }}>Ram</th>
                </tr>
              </thead>
              <tbody>
                {globalImeiCode &&
                  globalImeiCode
                    .filter((item) => {
                      const search = searchTerm.toLowerCase();
                      const imeiMatch = item.imeiNo
                        ?.toLowerCase()
                        .includes(search);
                      const mobileMatch =
                        item.user?.mobile?.includes(searchTerm);
                      const nameMatch = item.user?.name
                        ?.toLowerCase()
                        .includes(search);
                      const brandMatch = item.brand
                        ?.toLowerCase()
                        .includes(search);
                      const modelMatch = item.model
                        ?.toLowerCase()
                        .includes(search);
                      const colorMatch = item.color
                        ?.toLowerCase()
                        .includes(search);
                      const storageMatch = item.rom
                        ?.toLowerCase()
                        .includes(search);
                      const ramMatch = item.ram?.toLowerCase().includes(search);

                      const status =
                        item.globalImeiStatus === 0 ||
                        item.globalImeiStatus === false
                          ? "Pending"
                          : item.globalImeiStatus === 1
                          ? "Approved"
                          : "Rejected";

                      const statusMatch =
                        filterStatus === "All" || status === filterStatus;

                      const searchMatch =
                        imeiMatch ||
                        mobileMatch ||
                        nameMatch ||
                        brandMatch ||
                        modelMatch ||
                        colorMatch ||
                        storageMatch ||
                        ramMatch;
                      const missingUserInfo =
                        !item.user?.name && !item.user?.mobile;

                      // Special condition for "MissingUserInfo" button
                      if (filterStatus === "MissingUserInfo") {
                        return missingUserInfo && searchMatch;
                      }
                      const FoundUserInfo =
                        item.user?.name && item.user?.mobile;

                      // Special condition for "MissingUserInfo" button
                      if (filterStatus === "FoundUserInfo") {
                        return FoundUserInfo && searchMatch;
                      }
                      return statusMatch && searchMatch;
                    })
                    .map((item) => (
                      <tr key={item.id}>
                        <td style={{ width: "8%" }}>{item.imeiNo}</td>
                        <td style={{ width: "8%" }}>{item.reason || "N/A"}</td>
                        <td style={{ width: "8%" }}>
                          <select
                            value={
                              item.globalImeiStatus === 0 ||
                              item.globalImeiStatus === false
                                ? "Pending"
                                : item.globalImeiStatus === 1
                                ? "Approved"
                                : "Rejected"
                            }
                            onChange={(e) =>
                              handleUpdateFromTable(item, e.target.value)
                            }
                            style={{
                              padding: "4px 6px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              backgroundColor:
                                item.globalImeiStatus === 0 ||
                                item.globalImeiStatus === false
                                  ? "#fff3cd"
                                  : item.globalImeiStatus === 1
                                  ? "#d4edda"
                                  : "#f8d7da",
                              color:
                                item.globalImeiStatus === 0 ||
                                item.globalImeiStatus === false
                                  ? "#856404"
                                  : item.globalImeiStatus === 1
                                  ? "#155724"
                                  : "#721c24",
                              fontWeight: "500",
                            }}
                          >
                            <option value="Pending">Pending</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                          </select>
                        </td>

                        <td style={{ width: "8%" }}>
                          <Badge
                            color={getStatusBadgeColor(item.globalImeiStatus)}
                          >
                            {item.globalImeiStatus === 0 ||
                            item.globalImeiStatus === false
                              ? "Pending"
                              : item.globalImeiStatus === 1
                              ? "Approved"
                              : "Rejected"}
                          </Badge>
                        </td>
                        <td style={{ width: "8%" }}>
                          {item.user && item.user.name ? (
                            item.user.name
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => handleViewUserDetails(item)}
                            >
                              <EyeOutlined />
                            </Button>
                          )}
                        </td>
                        <td style={{ width: "8%" }}>
                          {item.user && item.user.mobile ? (
                            item.user.mobile
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => handleViewUserDetails(item)}
                            >
                              <EyeOutlined />
                            </Button>
                          )}
                        </td>
                        <td style={{ width: "8%" }}>
                          {item.imagesLive && item.imagesLive.length > 0 ? (
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleViewImages(item)}
                            >
                              <EyeOutlined /> View Images (
                              {item.imagesLive.length})
                            </Button>
                          ) : (
                            <span>No images</span>
                          )}
                        </td>
                        <td style={{ width: "8%" }}>{item.brand || "N/A"}</td>
                        <td style={{ width: "8%" }}>{item.model || "N/A"}</td>
                        <td style={{ width: "8%" }}>{item.color || "N/A"}</td>
                        <td style={{ width: "8%" }}>{item.rom || "N/A"}</td>
                        <td style={{ width: "8%" }}>{item.ram || "N/A"}</td>
                      </tr>
                    ))}
                {(!globalImeiCode || globalImeiCode.length === 0) && (
                  <tr>
                    <td colSpan="12" className="text-center">
                      No IMEI records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Card>
      </Container>

      {/* Image Modal */}
      <Modal
        isOpen={imageModalVisible}
        toggle={() => setImageModalVisible(!imageModalVisible)}
        className="modal-lg"
      >
        <div className="modal-header d-flex justify-content-between align-items-center">
          <h5 className="modal-title">
            IMEI Images: {selectedRecord?.imeiNo || ""}
          </h5>
          <div className="d-flex align-items-center">
            <select
              value={currentStatus}
              onChange={(e) => handleUpdate(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                backgroundColor:
                  currentStatus === "Pending"
                    ? "#fff3cd"
                    : currentStatus === "Approved"
                    ? "#d4edda"
                    : "#f8d7da",
                color:
                  currentStatus === "Pending"
                    ? "#856404"
                    : currentStatus === "Approved"
                    ? "#155724"
                    : "#721c24",
                fontWeight: "500",
                cursor: "pointer",
                outline: "none",
                appearance: "none",
                minWidth: "150px",
              }}
            >
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>

            <Button close onClick={() => setImageModalVisible(false)} />
          </div>
        </div>

        <div className="modal-body">
          <h5>Images:</h5>
          <div className="d-flex flex-wrap justify-content-center gap-3">
            {currentImages.map((image, index) => (
              <div key={index} className="text-center">
                <img
                  src={image}
                  alt={`Image ${index + 1}`}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "400px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                  }}
                  crossOrigin="anonymous"
                />
                <p className="mt-2">Image {index + 1}</p>
              </div>
            ))}
            {currentImages.length === 0 && <p>No images available</p>}
          </div>
        </div>

        <div className="modal-footer">
          <Button color="secondary" onClick={() => setImageModalVisible(false)}>
            Close
          </Button>
        </div>
      </Modal>

      {/* User Details Modal */}
      <Modal
        isOpen={userModalVisible}
        toggle={() => setUserModalVisible(!userModalVisible)}
        className="modal-md"
      >
        <div className="modal-header">
          <h5 className="modal-title">User Details</h5>
          <Button close onClick={() => setUserModalVisible(false)} />
        </div>

        <div className="modal-body">
          {loadingUserDetails ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-2">Loading user details...</p>
            </div>
          ) : selectedImeiDetails && selectedImeiDetails.user ? (
            <div>
              <Row className="mb-3">
                <Col xs="4" className="font-weight-bold">
                  Name:
                </Col>
                <Col xs="8">{selectedImeiDetails.user.name || "N/A"}</Col>
              </Row>
              <Row className="mb-3">
                <Col xs="4" className="font-weight-bold">
                  Mobile:
                </Col>
                <Col xs="8">{selectedImeiDetails.user.mobile || "N/A"}</Col>
              </Row>
              <Row className="mb-3">
                <Col xs="4" className="font-weight-bold">
                  Status:
                </Col>
                <Col xs="8">
                  <Badge
                    color={
                      selectedImeiDetails.user.status ? "success" : "danger"
                    }
                  >
                    {selectedImeiDetails.user.status ? "Active" : "Inactive"}
                  </Badge>
                </Col>
              </Row>
              {/* Display additional IMEI details if needed */}
              <Row className="mb-3">
                <Col xs="4" className="font-weight-bold">
                  IMEI Number:
                </Col>
                <Col xs="8">{selectedImeiDetails.imeiNo || "N/A"}</Col>
              </Row>
            </div>
          ) : (
            <div>
              <div className="text-center py-2 mt-2 bg-light rounded">
                <UserOutlined style={{ fontSize: "24px", color: "#aaa" }} />
                <p className="mt-2 text-muted small">Note: No User Found</p>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <Button color="secondary" onClick={() => setUserModalVisible(false)}>
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default GlobalImei;
